const getBanNumberFromListItem = (item) => {
  if (item == null || item === '') {
    return null;
  }

  if (typeof item === 'string' || typeof item === 'number') {
    return String(item);
  }

  return item.banNumber ?? item.BanNumber ?? item.account ?? item.Account ?? null;
};

export const resolveBansFromPaymentResultList = (banList, allBans) => {
  if (!banList?.length) {
    return [];
  }

  return banList
    .map((item) => {
      const banNumber = getBanNumberFromListItem(item);
      if (!banNumber) {
        return null;
      }

      const matchedBan = (allBans ?? []).find((ban) => ban.banNumber === banNumber);
      if (matchedBan) {
        return matchedBan;
      }

      if (typeof item === 'object') {
        return {...item, banNumber};
      }

      return {banNumber};
    })
    .filter(Boolean);
};
